<template>
	<div v-if="privateDocuments" class="list">
		<v-icon style="z-index: 10;" class="search-icon" v-if="!searchOpen" @click="searchOpen = true">search</v-icon>
		<v-icon class="close-search-icon" v-if="searchOpen" @click="searchOpen = false">close</v-icon>
		<v-date-picker
			first-day-of-week="1"
			v-on-clickaway="closeDatePicker"
			no-title
			v-model="stringDate"
			v-if="datepicker"
			dark
			v-on:change="setDate()"
			color="secondary"
		></v-date-picker>

		<v-data-table
			:headers="headers"
			:items="sortedDocuments"
			:loading="loading"
			item-key="_id"
			class="elevation-1"
			:rows-per-page-items="[20, 50, 100, 200, 500]"
			:pagination.sync="pagination"
			:total-items="privateTotal"
		>
			<template slot="items" slot-scope="props">
				<tr
					@click="!!rowClick && !props.item.isSearchDocument && rowClick(props.item)"
					:style="rowStyle && !props.item.isSearchDocument ? rowStyle(props.item) : ''"
					:class="{ search: props.item.isSearchDocument, 'row-action': !!rowClick && !props.item.isSearchDocument }"
				>
					<td
						v-for="(item, index) in items"
						:key="item.header"
						v-if="$options.filters.testAcl(item.acl)"
						@click="!props.item.isSearchDocument && privateCellClicked($event, item, props.item)"
						:class="{ 'cell-action': canCellClick(item, props.item) }"
					>
						<v-progress-circular
							indeterminate
							color="primary"
							v-if="props.item.loading && index === 0"
							class="item-tag-loader"
						></v-progress-circular>

						<!-- Search document -->
						<span v-if="props.item.isSearchDocument">
							<v-btn
								v-if="getSearchInput(item) && getSearchInput(item).type === 'date'"
								@click="openDatePicker(item.header)"
							>
								{{ searchRow[item.header] ? $options.filters.formatDate(searchRow[item.header]) : '--/--/--' }}
								<v-icon v-if="searchRow[item.header]" @click.stop="searchRow[item.header] = null">close</v-icon>
							</v-btn>
							<b-o-input
								:input="getSearchInput(item)"
								v-if="getSearchInput(item) && getSearchInput(item).type !== 'date'"
								v-model="searchRow[item.header]"
							></b-o-input>
						</span>

						<!--  Cell content-->
						<span v-if="!props.item.isSearchDocument">
							<span v-if="!!item.input && !!item.input(props.item)" @click="$event.stopPropagation()">
								<b-o-input
									:input="item.input(props.item)"
									v-model="props.item[item.input(props.item).value]"
									@change="privateRowChange(item.input, props.item)"
								>
								</b-o-input>
							</span>

							<span v-if="!item.input || !item.input(props.item)">
								<a @click.stop="goToData(item, props.item)" v-if="item.type === 'data' && item.modelName !== 'groups'">
									<span> {{ getData(item, props.item) }}</span>
								</a>
								<span v-if="item.type === 'data' && item.modelName === 'groups'"> {{ getData(item, props.item) }}</span>
								<v-icon v-if="!!item.icon && item.icon(props.item)">
									{{ item.icon(props.item) }}
								</v-icon>
								<span v-if="(!item.icon || !item.icon(props.item)) && item.type !== 'data'">
									{{ item.value(props.item) }}</span
								>
							</span>
						</span>
					</td>
				</tr>
			</template>

			<template v-slot:footer v-if="listActions || internActions">
				<td :colspan="headers.length" class="align-left">
					<v-btn
						v-for="action in actions"
						:key="action.name"
						:disabled="actionsLoading[action.name]"
						@click="launchAction(action)"
						style="float: left;"
						color="primary"
					>
						<strong>{{ action.name }}</strong>
						<v-progress-circular indeterminate v-if="actionsLoading[action.name]"></v-progress-circular>
					</v-btn>
				</td>
			</template>
		</v-data-table>
	</div>
</template>
<script>
import BOInput from './boInput'
import { ERROR } from '../variables' // TODO opti , ADD_ID_TO_GET
import { mixin as clickaway } from 'vue-clickaway'

export default {
	components: { BOInput },
	mixins: [clickaway],
	props: ['documents', 'url', 'addedItems', 'listActions'],
	data() {
		return {
			/** *****item to override**********/
			items: [],
			rowClick: null,
			rowStyle: null,
			defaultSort: '',
			internActions: '',

			/** *****private item pagination//sort//fitler**********/
			searchRow: null,
			getDataTimeout: null,
			searchOpen: false,
			stringDate: null,
			datepicker: false,
			dateSearchItem: '',
			loading: false,
			pagination: {
				rowsPerPage: 20,
			},
			privateDocuments: [],
			privateTotal: 0,
			actionsLoading: {},
		}
	},
	methods: {
		getData(item, row) {
			let attributeName = item.filter && item.filter.name ? item.filter.name : item.header
			if (!row[attributeName]) {
				return ''
			}

			if (item.fullObject === true) {
				return this.$store.getters.formatData(item.modelName, row[attributeName])
			} else {
				let object = this.$store.getters.getDataById(item.modelName, row[attributeName])
				if (object === false) {
					// this.$store.dispatch(ADD_ID_TO_GET, { modelName: item.modelName, id: row[attributeName] })
					return 'non accessible'
				}
				return this.$store.getters.formatData(item.modelName, object)
			}
		},
		goToData(item, row) {
			let id = item.fullObject ? row[item.header]._id : row[item.header]
			switch (item.modelName) {
				case 'models':
					this.$router.push({ name: 'ModelDetail', params: { id: id } })
					break
				case 'users':
					this.$router.push({ name: 'UserDetail', params: { id: id } })
					break
				case 'cars':
					this.$router.push({ name: 'CarDetail', params: { id: id } })
					break
				case 'partners':
					this.$router.push({ name: 'PartnerDetail', params: { id: id } })
					break
				default:
					break
			}
		},
		sortLocal(items) {
			let res
			if (!this.searchOpen) {
				res = items
			} else {
				res = items.filter((el) => {
					let isOkay = true
					let searchValue
					if (this.searchRow) {
						let searchItems = this.items
						for (let i = 0; i < searchItems.length; i++) {
							searchValue = this.searchRow[searchItems[i].header]
							if (searchValue) {
								if (searchItems[i].localFilter) {
									isOkay = isOkay && searchItems[i].localFilter(searchValue, searchItems[i].value(el), el)
								} else {
									let testString = searchItems[i].value(el) + ''
									isOkay = isOkay && testString.includes(this.searchRow[searchItems[i].header])
								}
							}
						}
					}

					return isOkay
				})
			}
			if (this.pagination.sortBy) {
				let sortItem = this.items.find((el) => el.header === this.pagination.sortBy)
				res.sort((el1, el2) => {
					if (sortItem.value(el2) > sortItem.value(el1)) {
						return this.pagination.descending ? -1 : 1
					} else if (sortItem.value(el1) > sortItem.value(el2)) {
						return this.pagination.descending ? 1 : -1
					}
					return 0
				})
			}

			this.privateTotal = res.length

			if (this.pagination.rowsPerPage !== -1) {
				return res.slice(
					this.pagination.rowsPerPage * (this.pagination.page - 1),
					this.pagination.rowsPerPage * this.pagination.page,
				)
			}

			return res
		},
		getItemFilterString(item, cellValue) {
			let attributeName = item.filter && item.filter.name ? item.filter.name : item.header
			if (item.type === 'data' || (item.filter && item.filter.type === 'data')) {
				if (item.fullObject) {
					if (cellValue.length === 1) {
						return attributeName + '._id:' + cellValue[0] + ';'
					} else {
						return attributeName + '._id:$in:' + cellValue + ';'
					}
				} else {
					if (cellValue.length === 1) {
						return attributeName + ':' + cellValue[0] + ';'
					} else {
						return attributeName + ':$in:' + cellValue + ';'
					}
				}
			}

			if (item.filter) {
				if (item.filter.type === 'custom') {
					return item.filter.customFilter(cellValue)
				} else if (item.filter.type === 'date') {
					let dateBegin = new Date(cellValue).toISOString().split('T')[0]
					let dateEnd = new Date(cellValue)
					dateEnd.setDate(dateEnd.getDate() + 1)
					dateEnd = dateEnd.toISOString().split('T')[0]

					return attributeName + ':$gte:' + dateBegin + ';' + attributeName + ':$lt:' + dateEnd + ';'
				} else if (item.filter.type === 'multi-select') {
					let operator = item.filter.searchType ? item.filter.searchType : '|'
					let res = operator === '&' ? '$and:[' : '$or:['

					for (let i = 0; i < cellValue.length; i++) {
						res += attributeName + ':' + cellValue[i] + ';'
					}
					res += '];'
					return res
				} else if (item.filter.type === 'multiple') {
					if (item.filter.separator) {
						cellValue = cellValue.split(item.filter.separator)
					} else {
						cellValue = cellValue.split(' ')
					}
					attributeName = attributeName.split(',')
					let res = '$and:['
					for (let i = 0; i < cellValue.length; i++) {
						res += '$or:['
						for (let j = 0; j < attributeName.length; j++) {
							if (attributeName[j].length > 0) {
								res += attributeName[j] + ':$regex:' + cellValue[i] + ';'
							}
						}
						res += '];'
					}
					res += '];'
					return res
				} else if (item.filter.type === 'address') {
					cellValue = cellValue.split(' ')
					let res = '$and:['
					for (let i = 0; i < cellValue.length; i++) {
						res +=
							'$or:[' +
							attributeName +
							'.street:$regex:' +
							cellValue[i] +
							';' +
							attributeName +
							'.city:$regex:' +
							cellValue[i] +
							';'

						if (!isNaN(Number(cellValue[i]))) {
							res += attributeName + '.postalCode:$number:' + cellValue[i] + ';'
						}
						res += '];'
					}
					res += '];'
					return res
				} else if (item.filter.type === 'number') {
					if (!isNaN(Number(cellValue))) {
						return attributeName + ':$number:' + cellValue + ';'
					}
				} else if (item.filter.type === 'checkbox') {
					return attributeName + ':$eq:' + cellValue + ';'
				}
			}

			return attributeName + ':$regex:' + cellValue + ';'
		},
		getFilter() {
			let filter = ''

			if (this.searchOpen) {
				let hasValue
				let searchFilters = ''
				let searchItems = this.items.filter((el) => el.filter !== false)
				for (let i = 0; i < searchItems.length; i++) {
					hasValue =
						this.searchRow[searchItems[i].header] !== undefined &&
						this.searchRow[searchItems[i].header] !== null &&
						((searchItems[i].filter &&
							(searchItems[i].filter.type === 'date' || searchItems[i].filter.type === 'checkbox')) ||
							this.searchRow[searchItems[i].header].length > 0)
					if (hasValue) {
						searchFilters += this.getItemFilterString(searchItems[i], this.searchRow[searchItems[i].header])
					}
				}
				if (searchFilters.length > 0) {
					if (this.url.includes('?filter=')) {
						filter +=
							(this.url[this.url.length - 1] !== ';' && this.url[this.url.length - 1] !== '=' ? ';' : '') +
							'$and:[' +
							searchFilters +
							'];'
					} else {
						filter += '?filter=$and:[' + searchFilters + '];'
					}
				}
			}

			return filter
		},
		async getDataFromApi() {
			let filter = this.getFilter()
			if (this.pagination.rowsPerPage !== -1) {
				filter +=
					((this.url + filter).includes('?') ? '&' : '?') +
					'limit=' +
					this.pagination.rowsPerPage +
					'&page=' +
					this.pagination.page
			}

			if (this.pagination.sortBy) {
				let sortItem = this.items.find((el) => el.header === this.pagination.sortBy)
				if (sortItem) {
					let sortFilter = sortItem.sort ? sortItem.sort : sortItem.header
					filter +=
						((this.url + filter).includes('?') ? '&' : '?') +
						'sort=' +
						(this.pagination.descending ? '-' : '') +
						sortFilter
				}
			}

			try {
				this.loading = true
				let response = await this.axios.get(this.url + filter)
				if (this.formatData) {
					this.privateDocuments = this.formatData(response.data.resources)
				} else {
					this.privateDocuments = response.data.resources
				}
				this.privateTotal = response.data.totalItem
				this.loading = false
			} catch (err) {
				this.loading = false
				this.$store.dispatch(ERROR, err)
			}
		},
		getSearchInput(item) {
			let res = {
				label: '',
				type: 'text',
			}
			if (item.icon) {
				return null
			}

			if (item.filter !== false) {
				if (item && (item.type === 'data' || (item.filter && item.filter.type === 'data'))) {
					res.type = 'data'
					res.multiple = true
					res.modelName = item.type === 'data' ? item.modelName : item.filter.modelName
				} else if (!!item.filter) {
					if (item.filter.type === 'checkbox') {
						res.type = 'checkboxWithNull'
					} else if (item.filter.type === 'custom') {
						res.type = item.filter.inputType
					} else if (item.filter.type === 'multi-select') {
						res.type = 'multi-select'
						res.multiple = true
						res.values = item.filter.values
						res.label = item.filter.searchType === '&' ? 'and' : 'or'

						if (item.filter.itemText) {
							res.itemText = item.filter.itemText
						}
						if (item.filter.itemValue) {
							res.itemValue = item.filter.itemValue
						}
					} else if (item.filter.type !== 'address' && item.filter.type !== 'multiple' && item.filter.type) {
						res.type = item.filter.type
					}
				}
				return res
			} else {
				return null
			}
		},
		closeDatePicker() {
			this.datepicker = false
			this.stringDate = null
		},
		setDate() {
			this.searchRow[this.dateSearchItem] = new Date(this.stringDate)
			this.closeDatePicker()
		},
		openDatePicker(item) {
			this.datepicker = true
			this.dateSearchItem = item
		},
		canCellClick(item, rowItem) {
			if (item.cellClick && (!item.disabled || !item.disabled(rowItem))) {
				return true
			}
			return false
		},
		async privateCellClicked(event, item, rowItem) {
			if (this.canCellClick(item, rowItem)) {
				this.$set(rowItem, 'loading', true)
				try {
					await item.cellClick(rowItem)
				} catch (err) {
					this.$store.dispatch(ERROR, err)
				}
				this.$set(rowItem, 'loading', false)
				return event.stopPropagation()
			}
		},
		async privateRowChange(inputFunc, rowItem) {
			if (inputFunc && inputFunc(rowItem) && inputFunc(rowItem).change) {
				this.$set(rowItem, 'loading', true)
				try {
					await inputFunc(rowItem).change(rowItem)
				} catch (err) {
					this.$store.dispatch(ERROR, err)
				}
				this.$set(rowItem, 'loading', false)
			}
		},
		async launchAction(action) {
			if (action && action.function) {
				this.$set(this.actionsLoading, action.name, true)
				try {
					await action.function(this.getFilter())
				} catch (err) {
					this.$store.dispatch(ERROR, err)
				}

				this.$set(this.actionsLoading, action.name, false)
			}
		},
		initSearchRow() {
			let searchRow = {
				isSearchDocument: true,
			}

			for (let i = 0; i < this.items.length; i++) {
				searchRow[this.items[i].header] = null
			}

			this.searchRow = searchRow
		},
		initSort() {
			if (this.defaultSort) {
				if (this.defaultSort[0] === '-') {
					this.pagination.sortBy = this.defaultSort.split('-')[1]
					this.pagination.descending = true
				} else {
					this.pagination.sortBy = this.defaultSort
					this.pagination.descending = false
				}
			}
		},
		update(delay) {
			if (this.url) {
				if (this.getDataTimeout) {
					clearTimeout(this.getDataTimeout)
				}

				this.getDataTimeout = setTimeout(this.getDataFromApi, delay)
			}
		},
		initData() {
			if (this.url) {
				this.update(300)
			} else if (this.documents) {
				if (this.formatData) {
					this.privateDocuments = this.formatData(this.documents)
				} else {
					this.privateDocuments = this.documents
				}
				this.privateTotal = this.documents.length
			}
		},
		initAddedItems() {
			if (this.addedItems) {
				this.items = this.items.concat(this.addedItems)
			}
		},
	},
	computed: {
		actions() {
			if (this.listActions && this.internActions) {
				return this.listActions.concat(this.internActions)
			}

			if (this.listActions) {
				return this.listActions
			}

			if (this.internActions) {
				return this.internActions
			}

			return null
		},
		sortedDocuments() {
			if (this.url) {
				if (!this.searchOpen) {
					return this.privateDocuments
				} else {
					return [this.searchRow].concat(this.privateDocuments)
				}
			} else {
				if (!this.searchOpen) {
					return this.sortLocal(this.privateDocuments)
				} else {
					return [this.searchRow].concat(this.sortLocal(this.privateDocuments))
				}
			}
		},
		headers() {
			return this.items.reduce((ac, el) => {
				if (this.$options.filters.testAcl(el.acl)) {
					//  TODO : local ==> enelever le && !!this.url
					if (typeof el.header === 'function') {
						ac.push({ text: el.header(), value: el.header, sortable: el.sort !== false })
					} else {
						ac.push({ text: el.header, value: el.header, sortable: el.sort !== false })
					}
				}
				return ac
			}, [])
		},
	},
	watch: {
		addedItems: function(addedItems, oldItems) {
			if (addedItems && !oldItems) {
				this.initAddedItems()
			} else if (oldItems && !addedItems) {
				for (let i = this.items.length - 1; i >= 0; i--) {
					for (let j = 0; j < oldItems.length; j++) {
						if (oldItems[j].header === this.items[i].header) {
							this.items.splice(i, 1)
							break
						}
					}
				}
			}
		},
		documents: function() {
			this.initData()
		},
		url: function() {
			this.initData()
		},
		defaultSort: {
			handler() {
				this.initSort()
			},
			deep: true,
		},
		searchOpen: function() {
			this.update(300)
		},
		searchRow: {
			handler() {
				this.update(1000)
			},
			deep: true,
		},
		pagination: function(newA, oldA) {
			this.update(300)
		},
	},
	mounted() {
		this.initSearchRow()
		this.initData()
		this.initSort()
		this.initAddedItems()
	},
}
</script>

<style lang="scss">
@import '../assets/global.scss';

.list {
	position: relative;

	tr {
		position: relative;
		.item-tag-loader {
			position: absolute;
		}
	}
	.v-input {
		display: flex;
		justify-content: center;
		align-items: center;

		.v-input__slot {
			margin-bottom: 0 !important;
		}
		&.v-input--checkbox .v-input__control {
			height: 16px !important;
		}
	}

	.row-action {
		cursor: pointer;
	}
	.cell-action {
		color: $primary-color;
		cursor: pointer;
		i {
			color: $primary-color;
		}
	}

	.search-icon {
		position: absolute;
		height: 58px;
	}
	.close-search-icon {
		position: absolute;
		height: 58px;
		transform: translateY(100%);
	}
	.v-picker {
		position: fixed;
		z-index: 100000;
		left: 50%;
		top: 50px;
		transform: translate(-50%);
	}

	.search {
		background-color: $secondary-color;
	}
}
</style>



// WEBPACK FOOTER //
// src/baseComponents/list.vue